import { SummaryStatsCard } from '@exam-center/components';
import { useExamCenter } from '@exam-center/exam-center-details';
import { useGetExamLocationRequestInfoCountByStatusQuery } from '@exam-center/graphql';
import { Flex } from '@shared/components';

export default function ExamLocationRequestStatusSummary() {
  const { examCenter } = useExamCenter();

  const { data, loading: isLoading } = useGetExamLocationRequestInfoCountByStatusQuery({
    variables: {
      getExamLocationRequestInfoCountByExamCenterCodeInput: {
        examCenterCode: examCenter.code,
      },
    },
    skip: !examCenter.code,
  });

  const stats =
    data?.ecGetExamLocationRequestInfoCountByExamCenterCode?.examLocationRequestInfoCountByStatus;
  const numberOfDraft = stats?.draft ?? 0;
  const numberOfInReview = stats?.inReview ?? 0;
  const numberOfRejected = stats?.rejected ?? 0;

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(4) })}>
      <SummaryStatsCard
        title='แบบร่าง'
        displayValue={`${numberOfDraft} รายการ`}
        loading={isLoading}
        color='info'
      />
      <SummaryStatsCard
        title='อยู่ระหว่างอนุมัติ'
        displayValue={`${numberOfInReview} รายการ`}
        loading={isLoading}
        color='warning'
      />
      <SummaryStatsCard
        title='ไม่อนุมัติ'
        displayValue={`${numberOfRejected} รายการ`}
        loading={isLoading}
        color='error'
      />
    </Flex>
  );
}
